// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "service/mlmodel/v1/mlmodel.proto" (package "viam.service.mlmodel.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { GetStatusResponse } from "../../../common/v1/common";
import { GetStatusRequest } from "../../../common/v1/common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
/**
 * @generated from protobuf message viam.service.mlmodel.v1.InferRequest
 */
export interface InferRequest {
    /**
     * name of the model service
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * the input data is provided as set of named flat tensors
     *
     * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensors input_tensors = 3;
     */
    inputTensors?: FlatTensors;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.InferResponse
 */
export interface InferResponse {
    /**
     * the output data is provided as a set of named flat tensors
     *
     * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensors output_tensors = 3;
     */
    outputTensors?: FlatTensors;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.MetadataRequest
 */
export interface MetadataRequest {
    /**
     * name of the model service
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Additional arguments to the method
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.MetadataResponse
 */
export interface MetadataResponse {
    /**
     * this is the metadata associated with the ML model
     *
     * @generated from protobuf field: viam.service.mlmodel.v1.Metadata metadata = 1;
     */
    metadata?: Metadata;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.Metadata
 */
export interface Metadata {
    /**
     * name of the model
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * type of model e.g. object_detector, text_classifier
     *
     * @generated from protobuf field: string type = 2;
     */
    type: string;
    /**
     * description of the model
     *
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * the necessary input arrays/tensors for an inference, order matters
     *
     * @generated from protobuf field: repeated viam.service.mlmodel.v1.TensorInfo input_info = 4;
     */
    inputInfo: TensorInfo[];
    /**
     * the output arrays/tensors of the model, order matters
     *
     * @generated from protobuf field: repeated viam.service.mlmodel.v1.TensorInfo output_info = 5;
     */
    outputInfo: TensorInfo[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.TensorInfo
 */
export interface TensorInfo {
    /**
     * name of the data in the array/tensor
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * description of the data in the array/tensor
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * data type of the array/tensor, e.g. float32, float64, uint8
     *
     * @generated from protobuf field: string data_type = 3;
     */
    dataType: string;
    /**
     * shape of the array/tensor (-1 for unknown)
     *
     * @generated from protobuf field: repeated int32 shape = 4;
     */
    shape: number[];
    /**
     * files associated with the array/tensor, like for category labels
     *
     * @generated from protobuf field: repeated viam.service.mlmodel.v1.File associated_files = 5;
     */
    associatedFiles: File[];
    /**
     * anything else you want to say
     *
     * @generated from protobuf field: google.protobuf.Struct extra = 99;
     */
    extra?: Struct;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.File
 */
export interface File {
    /**
     * name of the file, with file extension
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * description of what the file contains
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * How to associate the arrays/tensors to the labels in the file
     *
     * @generated from protobuf field: viam.service.mlmodel.v1.LabelType label_type = 3;
     */
    labelType: LabelType;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataInt8
 */
export interface FlatTensorDataInt8 {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt8
 */
export interface FlatTensorDataUInt8 {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataInt16
 */
export interface FlatTensorDataInt16 {
    /**
     * packs two 16-bit numbers per entry - explicitly little-endian
     * so big-endian producers/consumers must compensate
     *
     * @generated from protobuf field: repeated fixed32 data = 1 [packed = true];
     */
    data: number[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt16
 */
export interface FlatTensorDataUInt16 {
    /**
     * packs two 16-bit numbers per entry - explicitly little-endian
     * so big-endian producers/consumers must compensate
     *
     * @generated from protobuf field: repeated fixed32 data = 1 [packed = true];
     */
    data: number[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataInt32
 */
export interface FlatTensorDataInt32 {
    /**
     * @generated from protobuf field: repeated sfixed32 data = 1 [packed = true];
     */
    data: number[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt32
 */
export interface FlatTensorDataUInt32 {
    /**
     * @generated from protobuf field: repeated fixed32 data = 1 [packed = true];
     */
    data: number[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataInt64
 */
export interface FlatTensorDataInt64 {
    /**
     * @generated from protobuf field: repeated sfixed64 data = 1 [packed = true];
     */
    data: string[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt64
 */
export interface FlatTensorDataUInt64 {
    /**
     * @generated from protobuf field: repeated fixed64 data = 1 [packed = true];
     */
    data: string[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataFloat
 */
export interface FlatTensorDataFloat {
    /**
     * @generated from protobuf field: repeated float data = 1 [packed = true];
     */
    data: number[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensorDataDouble
 */
export interface FlatTensorDataDouble {
    /**
     * @generated from protobuf field: repeated double data = 1 [packed = true];
     */
    data: number[];
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensor
 */
export interface FlatTensor {
    /**
     * the shape of the provided tensor as a list of integer extents
     *
     * @generated from protobuf field: repeated fixed64 shape = 1;
     */
    shape: string[];
    /**
     * @generated from protobuf oneof: tensor
     */
    tensor: {
        oneofKind: "int8Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataInt8 int8_tensor = 2;
         */
        int8Tensor: FlatTensorDataInt8;
    } | {
        oneofKind: "uint8Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataUInt8 uint8_tensor = 3;
         */
        uint8Tensor: FlatTensorDataUInt8;
    } | {
        oneofKind: "int16Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataInt16 int16_tensor = 4;
         */
        int16Tensor: FlatTensorDataInt16;
    } | {
        oneofKind: "uint16Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataUInt16 uint16_tensor = 5;
         */
        uint16Tensor: FlatTensorDataUInt16;
    } | {
        oneofKind: "int32Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataInt32 int32_tensor = 6;
         */
        int32Tensor: FlatTensorDataInt32;
    } | {
        oneofKind: "uint32Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataUInt32 uint32_tensor = 7;
         */
        uint32Tensor: FlatTensorDataUInt32;
    } | {
        oneofKind: "int64Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataInt64 int64_tensor = 8;
         */
        int64Tensor: FlatTensorDataInt64;
    } | {
        oneofKind: "uint64Tensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataUInt64 uint64_tensor = 9;
         */
        uint64Tensor: FlatTensorDataUInt64;
    } | {
        oneofKind: "floatTensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataFloat float_tensor = 10;
         */
        floatTensor: FlatTensorDataFloat;
    } | {
        oneofKind: "doubleTensor";
        /**
         * @generated from protobuf field: viam.service.mlmodel.v1.FlatTensorDataDouble double_tensor = 11;
         */
        doubleTensor: FlatTensorDataDouble;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message viam.service.mlmodel.v1.FlatTensors
 */
export interface FlatTensors {
    /**
     * A name-indexed collection of flat tensor objects
     *
     * @generated from protobuf field: map<string, viam.service.mlmodel.v1.FlatTensor> tensors = 1;
     */
    tensors: {
        [key: string]: FlatTensor;
    };
}
/**
 * @generated from protobuf enum viam.service.mlmodel.v1.LabelType
 */
export enum LabelType {
    /**
     * @generated from protobuf enum value: LABEL_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * the value of the arrays/tensor is the label index
     *
     * @generated from protobuf enum value: LABEL_TYPE_TENSOR_VALUE = 1;
     */
    TENSOR_VALUE = 1,
    /**
     * the position of the tensor value in the axis is the label index
     *
     * @generated from protobuf enum value: LABEL_TYPE_TENSOR_AXIS = 2;
     */
    TENSOR_AXIS = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class InferRequest$Type extends MessageType<InferRequest> {
    constructor() {
        super("viam.service.mlmodel.v1.InferRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "input_tensors", kind: "message", T: () => FlatTensors },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.InferRequest
 */
export const InferRequest = new InferRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferResponse$Type extends MessageType<InferResponse> {
    constructor() {
        super("viam.service.mlmodel.v1.InferResponse", [
            { no: 3, name: "output_tensors", kind: "message", T: () => FlatTensors }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.InferResponse
 */
export const InferResponse = new InferResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetadataRequest$Type extends MessageType<MetadataRequest> {
    constructor() {
        super("viam.service.mlmodel.v1.MetadataRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.MetadataRequest
 */
export const MetadataRequest = new MetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MetadataResponse$Type extends MessageType<MetadataResponse> {
    constructor() {
        super("viam.service.mlmodel.v1.MetadataResponse", [
            { no: 1, name: "metadata", kind: "message", T: () => Metadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.MetadataResponse
 */
export const MetadataResponse = new MetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Metadata$Type extends MessageType<Metadata> {
    constructor() {
        super("viam.service.mlmodel.v1.Metadata", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "input_info", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TensorInfo },
            { no: 5, name: "output_info", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TensorInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.Metadata
 */
export const Metadata = new Metadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TensorInfo$Type extends MessageType<TensorInfo> {
    constructor() {
        super("viam.service.mlmodel.v1.TensorInfo", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "data_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "shape", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "associated_files", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => File },
            { no: 99, name: "extra", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.TensorInfo
 */
export const TensorInfo = new TensorInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class File$Type extends MessageType<File> {
    constructor() {
        super("viam.service.mlmodel.v1.File", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "label_type", kind: "enum", T: () => ["viam.service.mlmodel.v1.LabelType", LabelType, "LABEL_TYPE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.File
 */
export const File = new File$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataInt8$Type extends MessageType<FlatTensorDataInt8> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataInt8", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataInt8
 */
export const FlatTensorDataInt8 = new FlatTensorDataInt8$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataUInt8$Type extends MessageType<FlatTensorDataUInt8> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataUInt8", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt8
 */
export const FlatTensorDataUInt8 = new FlatTensorDataUInt8$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataInt16$Type extends MessageType<FlatTensorDataInt16> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataInt16", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 7 /*ScalarType.FIXED32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataInt16
 */
export const FlatTensorDataInt16 = new FlatTensorDataInt16$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataUInt16$Type extends MessageType<FlatTensorDataUInt16> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataUInt16", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 7 /*ScalarType.FIXED32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt16
 */
export const FlatTensorDataUInt16 = new FlatTensorDataUInt16$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataInt32$Type extends MessageType<FlatTensorDataInt32> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataInt32", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 15 /*ScalarType.SFIXED32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataInt32
 */
export const FlatTensorDataInt32 = new FlatTensorDataInt32$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataUInt32$Type extends MessageType<FlatTensorDataUInt32> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataUInt32", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 7 /*ScalarType.FIXED32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt32
 */
export const FlatTensorDataUInt32 = new FlatTensorDataUInt32$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataInt64$Type extends MessageType<FlatTensorDataInt64> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataInt64", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 16 /*ScalarType.SFIXED64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataInt64
 */
export const FlatTensorDataInt64 = new FlatTensorDataInt64$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataUInt64$Type extends MessageType<FlatTensorDataUInt64> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataUInt64", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 6 /*ScalarType.FIXED64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataUInt64
 */
export const FlatTensorDataUInt64 = new FlatTensorDataUInt64$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataFloat$Type extends MessageType<FlatTensorDataFloat> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataFloat", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataFloat
 */
export const FlatTensorDataFloat = new FlatTensorDataFloat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensorDataDouble$Type extends MessageType<FlatTensorDataDouble> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensorDataDouble", [
            { no: 1, name: "data", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensorDataDouble
 */
export const FlatTensorDataDouble = new FlatTensorDataDouble$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensor$Type extends MessageType<FlatTensor> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensor", [
            { no: 1, name: "shape", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 6 /*ScalarType.FIXED64*/ },
            { no: 2, name: "int8_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataInt8 },
            { no: 3, name: "uint8_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataUInt8 },
            { no: 4, name: "int16_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataInt16 },
            { no: 5, name: "uint16_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataUInt16 },
            { no: 6, name: "int32_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataInt32 },
            { no: 7, name: "uint32_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataUInt32 },
            { no: 8, name: "int64_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataInt64 },
            { no: 9, name: "uint64_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataUInt64 },
            { no: 10, name: "float_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataFloat },
            { no: 11, name: "double_tensor", kind: "message", oneof: "tensor", T: () => FlatTensorDataDouble }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensor
 */
export const FlatTensor = new FlatTensor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlatTensors$Type extends MessageType<FlatTensors> {
    constructor() {
        super("viam.service.mlmodel.v1.FlatTensors", [
            { no: 1, name: "tensors", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => FlatTensor } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.service.mlmodel.v1.FlatTensors
 */
export const FlatTensors = new FlatTensors$Type();
/**
 * @generated ServiceType for protobuf service viam.service.mlmodel.v1.MLModelService
 */
export const MLModelService = new ServiceType("viam.service.mlmodel.v1.MLModelService", [
    { name: "Infer", options: { "google.api.http": { post: "/viam/api/v1/service/mlmodel/{name}/infer" } }, I: InferRequest, O: InferResponse },
    { name: "Metadata", options: { "google.api.http": { get: "/viam/api/v1/service/mlmodel/{name}/metadata" } }, I: MetadataRequest, O: MetadataResponse },
    { name: "GetStatus", options: { "google.api.http": { get: "/viam/api/v1/service/mlmodel/{name}/get_status" } }, I: GetStatusRequest, O: GetStatusResponse }
]);
